<template>
  <div class="footer">
    <div class="footerBox">
      <!-- <div class="footerContent">
        <div class="footerContent_left">
          <span class="leftContentTitle">{{ $t('footer.contact') }}</span>
          <span class="leftContentText">{{ $t('footer.update') }}</span>
          <div>
            <input
              type="text"
              class="leftContentInput"
            >
            <div class="leftContentBtn">Subscribe</div>
          </div>
        </div>
        <ul class="LinkContent">
          <li><img
              src="@/assets/images/facebook.svg"
              alt=""
            ></li>
          <li><img
              src="@/assets/images/ig.svg"
              alt=""
            ></li>
          <li><img
              src="@/assets/images/youtube.svg"
              alt=""
            ></li>
        </ul>
        <ul class="footerContent_right">
          <li>{{ $t('footer.partner') }}</li>
          <li>
            <router-link :to="{name:'privacy'}">
              {{ $t('footer.privacy') }}
            </router-link>
          </li>
          <li>{{ $t('footer.terms') }}</li>
        </ul>
      </div> -->
      <div class="footerBox_verbar"></div>
      <div class="textbottom">
        <span>{{ $t('footer.copyrightLeft')+ new Date().getFullYear() + $t('footer.copyrightRight') }}</span>
        <router-link :to="{name:'privacy'}">
          {{ $t('footer.privacy') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.footer {
  width: 100%;
  background: #0f96bb;
}
.footerBox {
  margin: 0 auto;
  position: relative;
  max-width: 1280px;
  bottom: 0;
  color: #ffffff;
  padding: 35px 15px;
}
.footerContent {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  margin-bottom: 35px;
}
.footerContent_left {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.leftContentTitle {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  cursor: default;
}
.leftContentText {
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  margin-bottom: 20px;
  cursor: default;
}
.leftContentInput {
  width: 300px;
  height: 50px;
  border-radius: 3px 0 0 3px;
  border: 0;
  float: left;
}
.leftContentBtn {
  width: 100px;
  height: 50px;
  border-radius: 3px;
  border: 0;
  background: #ffbf00;
  color: #ffffff;
  border-radius: 3px;
  float: left;
  text-align: center;
  line-height: 50px;
  cursor: pointer;
}
.LinkContent {
  list-style: none;
  margin: 0;
}
.LinkContent li {
  float: left;
  margin-right: 30px;
  cursor: pointer;
}
.footerContent_right {
  list-style: none;
  text-align: left;
  line-height: 30px;
  margin: 0;
  cursor: pointer;
}
.footerContent_right a {
  color: #fff;
}
.footerBox_verbar {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin: 30px auto;
}
.textbottom {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  > a {
    white-space: nowrap;
    color: white;
    padding: 0 40px 10px;
  }
}
@media (max-width: 1000px) and (min-width: 0px) {
  .footerBox {
    padding: 10px 30px;
  }
  .footerContent {
    flex-direction: column;
    margin-bottom: 0px;
  }
  .footerContent_left {
    margin-bottom: 15px;
  }
  .leftContentTitle {
    font-size: 1.1rem;
  }
  .leftContentText {
    font-size: 0.8rem;
  }
  .leftContentInput {
    width: 12rem;
    height: 35px;
  }
  .leftContentBtn {
    width: 85px;
    height: 35px;
    line-height: 35px;
    font-size: 0.8rem;
  }
  .footerContent_right {
    /* display: none; */
  }
  .LinkContent {
    padding: 0;
  }
  .LinkContent li {
    margin: 0 8px;
  }
  .LinkContent li img {
    width: 86%;
  }
  .footerBox_verbar {
    margin: 10px auto;
  }
  .textbottom {
    font-size: 0.7rem;
  }
}
</style>